// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"503":"11c7b93d","3226":"b7be268f","5365":"d1473934"}[chunkId] + ".chunk.css";
};